/** Result of one TCP 443 probe against a single platform host. */
export type TcpStatus = 'pending' | 'ok' | 'blocked'

/**
 * Result of the UDP 3478 probe.
 * - `ok`             STUN answered from the platform's subnet through a cone NAT
 * - `symmetric`      STUN answered, but the NAT re-maps per destination
 * - `subnet-blocked` public STUN answered, the platform's own did not
 * - `udp-blocked`    no STUN answered at all
 */
export type UdpStatus = 'pending' | 'ok' | 'symmetric' | 'subnet-blocked' | 'udp-blocked'

/** What the banner shows. */
export type OverallStatus = 'run' | 'ok' | 'warn' | 'fail'

/**
 * A phone needs both halves: a signalling path on TCP 443 and a media path on UDP. One reachable
 * host is enough to prove 443 is open, since the four hosts share a subnet, but the media path has
 * no such slack — anything short of a cone NAT on the platform's subnet is a problem worth showing.
 */
export function deriveOverallStatus(tcp: TcpStatus[], udp: UdpStatus): OverallStatus {
	if (udp === 'pending' || tcp.some((status) => status === 'pending')) return 'run'
	if (!tcp.some((status) => status === 'ok')) return 'fail'
	if (udp === 'ok') return 'ok'
	if (udp === 'symmetric') return 'warn'
	return 'fail'
}
